if (!customElements.get('multicolumn-icon')) {
  customElements.define(
    'multicolumn-icon',
    class MulticolumnIcon extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          slides: '.f-column',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
          swiperSlide: 'swiper-slide',
        };

        this.sectionId = this.dataset.sectionId;
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.slides = this.querySelectorAll(this.selectors.slides);
        this.sliderInstance = false;

        // Vérifier si swipe_on_mobile est activé
        if (!this.classList.contains('swipe-mobile')) {
          return;
        }

        // Media query pour mobile (< 768px)
        this.mql = window.matchMedia('(max-width: 767px)');
        
        // Initialiser selon l'écran
        this.handleResize();
        
        // Écouter les changements de taille d'écran
        this.mql.addEventListener('change', this.handleResize.bind(this));
      }

      handleResize() {
        if (this.mql.matches) {
          // En mobile : activer le swiper
          this.initSlider();
        } else {
          // En tablet/desktop : désactiver le swiper
          this.destroySlider();
        }
      }

      initSlider() {
        // Si le slider existe déjà, ne rien faire
        if (typeof this.sliderInstance === 'object') return;

        // Vérifier que FoxTheme.Carousel existe
        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          console.warn('FoxTheme.Carousel not available');
          return;
        }

        // Appliquer la classe swiper-slide à chaque enfant
        this.slides.forEach(slide => {
          if (!slide.classList.contains(this.classes.swiperSlide)) {
            slide.classList.add(this.classes.swiperSlide);
          }
        });

        // Appliquer les classes Swiper
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        // Récupérer le gap CSS
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 16;

        // Options du slider
        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          centeredSlides: false,
          loop: false,
          threshold: 5,
          watchSlidesProgress: true,
          touchRatio: 1,
          resistanceRatio: 0.85,

          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        };


        try {
          // Initialiser Swiper
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
          this.sliderInstance.init();
        } catch (error) {
          console.error('Error initializing swiper:', error);
        }
      }

      destroySlider() {
        // Si pas de slider, ne rien faire
        if (typeof this.sliderInstance !== 'object') return;

        // Retirer la classe swiper-slide de chaque enfant
        this.slides.forEach(slide => {
          slide.classList.remove(this.classes.swiperSlide);
        });

        // Retirer les classes Swiper
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        // Détruire l'instance Swiper
        try {
          this.sliderInstance.slider.destroy();
        } catch (error) {
          console.error('Error destroying swiper:', error);
        }
        this.sliderInstance = false;
      }

      disconnectedCallback() {
        // Nettoyer quand l'élément est retiré du DOM
        if (this.mql) {
          this.mql.removeEventListener('change', this.handleResize.bind(this));
        }
        this.destroySlider();
      }
    }
  );
}